import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "GPS System",
        price: 50,
        disprice: 40,
        stock: 10,
        content:
            "Stay on track with our advanced GPS Navigation System, designed for accurate real-time location tracking and seamless route planning.",
        description:
            "Our GPS Navigation System offers real-time traffic updates, voice-guided directions, and a user-friendly interface. With multi-destination support and offline maps, it ensures hassle-free travel anywhere you go.",
        category: ["Car Accessories", "Car Maintenance"],
        tags: ["GPS", "Navigation", "Car"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Screen Size", content: "7-inch HD Display" },
            { id: 2, title: "Maps", content: "Preloaded with US, Canada, and Mexico Maps" },
            { id: 3, title: "Connectivity", content: "Bluetooth & Wi-Fi Enabled" },
            { id: 4, title: "Voice Control", content: "Hands-Free Operation" },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Daniel Roberts",
                date: "March 15, 2025",
                rating: 5,
                content: "Very accurate GPS with clear voice navigation. It made my road trips so much easier!",
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Emily Carter",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Easy to use and reliable. The traffic updates are super helpful! Highly recommended!",
            },
        ],
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Car Tire",
        price: 80,
        disprice: 65,
        stock: 9,
        content:
            "Upgrade your ride with our high-performance Premium Car Tire, designed for superior grip, durability, and fuel efficiency.",
        description:
            "Our Premium Car Tire ensures a smooth and safe driving experience with enhanced traction, all-weather performance, and long-lasting tread life. Perfect for city and highway driving.",
        category: ["Car Maintenance", "Safety & Emergency"],
        tags: ["Tire", "Car", "Maintenance"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Tire Size", content: "205/55R16" },
            { id: 2, title: "Tread Life", content: "Up to 60,000 Miles" },
            { id: 3, title: "Weather Performance", content: "All-Season Traction" },
            { id: 4, title: "Warranty", content: "5-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Michael Johnson",
                date: "March 15, 2025",
                rating: 5,
                content: "Excellent grip and smooth ride! My car feels brand new with these tires.",
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Sarah Thompson",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Great tires for all weather conditions. Highly recommend for daily commuters!",
            },
        ],
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Emergency Toolkit",
        price: 45,
        disprice: 35,
        stock: 5,
        content:
            "Be prepared for any roadside emergency with our Car Emergency Toolkit, equipped with essential tools for quick fixes and safety.",
        description:
            "Our Car Emergency Toolkit includes a tire inflator, jumper cables, a multipurpose wrench, flashlight, and first-aid kit. Compact and easy to store, it's a must-have for every vehicle.",
        category: ["Car Maintenance", "Safety & Emergency"],
        tags: ["Toolkit", "Car", "Emergency"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Contents", content: "Jumper Cables, Wrench, Tire Inflator, Flashlight, First-Aid Kit" },
            { id: 2, title: "Storage Case", content: "Durable & Compact Carrying Case" },
            { id: 3, title: "Usage", content: "Ideal for Roadside Emergencies & Maintenance" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "David Wilson",
                date: "March 15, 2025",
                rating: 5,
                content: "A lifesaver on the road! The jumper cables and inflator came in handy during a breakdown.",
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Jessica Brown",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Great toolkit with all the essentials. Compact and easy to store in my trunk!",
            },
        ],
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Phone Mount",
        price: 25,
        disprice: 18,
        stock: 0,
        content:
            "Keep your phone secure and easily accessible while driving with our Universal Car Phone Mount, featuring a sturdy grip and 360-degree rotation.",
        description:
            "Our Universal Car Phone Mount provides a safe and convenient way to navigate, take calls, or control music hands-free. Designed for all phone sizes with a strong suction cup for dashboard or windshield mounting.",
        category: ["Car Accessories", "Technology & Gadgets"],
        tags: ["Phone", "Car", "Mount"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Compatibility", content: "Fits All Smartphone Sizes" },
            { id: 2, title: "Rotation", content: "360-Degree Adjustable Viewing" },
            { id: 3, title: "Mounting Options", content: "Dashboard & Windshield Suction Cup" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Michael Carter",
                date: "March 15, 2025",
                rating: 5,
                content: "Sturdy and reliable! Holds my phone perfectly without slipping.",
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Emma Davis",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Great phone mount! Easy to install and adjust for the perfect viewing angle.",
            },
        ],
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Car Pouch",
        price: 18,
        disprice: 15,
        stock: 15,
        content:
            "Maximize your car's storage space with our versatile Car Storage Pouch, perfect for organizing small items and keeping your vehicle tidy.",
        description:
            "Our Car Storage Pouch is designed to keep essential items organized and easily accessible. With a durable, compact design, it fits perfectly in your car’s interior, ideal for storing documents, gadgets, and other small essentials.",
        category: ["Car Accessories", "Travel & Luggage"],
        tags: ["Pouch", "Storage", "Car"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Capacity", content: "Spacious Enough for Documents, Gadgets, and Small Items" },
            { id: 2, title: "Material", content: "Durable & Water-Resistant Fabric" },
            { id: 3, title: "Design", content: "Compact & Lightweight for Easy Storage" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Sarah Johnson",
                date: "March 15, 2025",
                rating: 5,
                content: "This pouch is amazing! It keeps my car organized, and I can easily find my essentials.",
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Michael Lee",
                date: "March 20, 2025",
                rating: 4.7,
                content: "Great product! It holds a lot and fits perfectly in the car without taking up too much space.",
            },
        ],
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Car Engine Oil",
        price: 25,
        disprice: 20,
        stock: 12,
        content:
            "Maintain optimal engine performance with our premium Car Engine Oil, formulated to protect against wear and improve fuel efficiency.",
        description:
            "Our Car Engine Oil is designed to reduce friction and wear, while enhancing engine performance. Suitable for most car models, it helps improve fuel economy and offers protection against sludge and contaminants.",
        category: ["Car Maintenance", "Car Accessories"],
        tags: ["Oil", "Car", "Maintenance"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Viscosity", content: "5W-30 for Optimal Engine Performance" },
            { id: 2, title: "Protection", content: "Protects Against Engine Wear & Sludge Build-up" },
            { id: 3, title: "Compatibility", content: "Compatible with Most Vehicle Models" },
            { id: 4, title: "Eco-Friendly", content: "Low Emissions, Improved Fuel Efficiency" },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Lucas Gray",
                date: "March 15, 2025",
                rating: 5,
                content: "Great engine oil! I noticed smoother performance and better fuel efficiency.",
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Emma White",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Highly recommended! Keeps my engine running smoothly and quietly.",
            },
        ],
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Air Freshener",
        price: 10,
        disprice: 8,
        stock: 0,
        content:
            "Keep your car smelling fresh and clean with our Car Air Freshener, designed to eliminate odors and add a pleasant fragrance.",
        description:
            "Our Car Air Freshener is easy to use and long-lasting, available in a variety of refreshing scents. Perfect for creating a welcoming environment in your car.",
        category: ["Car Accessories", "Car Maintenance"],
        tags: ["Air", "Freshener", "Car"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Fragrance", content: "Fresh, Lavender, Citrus, Ocean Breeze" },
            { id: 2, title: "Duration", content: "Up to 30 Days of Freshness" },
            { id: 3, title: "Easy Use", content: "Simply Hang or Place in Car" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Amelia Carter",
                date: "March 15, 2025",
                rating: 5,
                content: "This air freshener smells amazing and lasts for weeks! My car always smells fresh.",
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Liam Roberts",
                date: "March 20, 2025",
                rating: 4.7,
                content: "Great scent and easy to use. Keeps my car smelling good all the time.",
            },
        ],
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Car Solar Battery",
        price: 120,
        disprice: 100,
        stock: 30,
        content:
            "Harness the power of the sun with our high-efficiency Car Solar Battery, designed to provide reliable power for your vehicle's electrical system.",
        description:
            "Our Car Solar Battery is ideal for maintaining the charge in your car’s battery, ensuring reliable performance even during long periods of inactivity. This eco-friendly option charges using solar energy and reduces your car's reliance on traditional power sources.",
        category: ["Car Accessories", "Technology & Gadgets"],
        tags: ["Solar", "Battery", "Car"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Capacity", content: "12V, 100Ah for Long-Lasting Power" },
            { id: 2, title: "Charging Method", content: "Solar-Powered for Sustainable Charging" },
            { id: 3, title: "Durability", content: "Weather-Resistant Design for Outdoor Use" },
            { id: 4, title: "Warranty", content: "2-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Olivia Harris",
                date: "March 15, 2025",
                rating: 5,
                content: "This solar battery is fantastic! It keeps my car charged without needing an outlet. Highly recommend!",
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "James Clark",
                date: "March 20, 2025",
                rating: 4.7,
                content: "Great eco-friendly option! It charges well even on cloudy days and helps reduce battery drain.",
            },
        ],
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Car Luggage",
        price: 80,
        disprice: 60,
        stock: 9,
        content:
            "Pack your essentials in style with our spacious and durable Car Luggage, designed for easy transport and maximum organization.",
        description:
            "Our Car Luggage is perfect for long trips and vacations, featuring ample space for clothes, shoes, and accessories. Made from durable, lightweight materials, this luggage ensures smooth travel and convenient storage in your vehicle.",
        category: ["Car Accessories", "Travel & Luggage"],
        tags: ["Luggage", "Car", "Travel"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Capacity", content: "Large Storage for Clothes, Shoes, & Accessories" },
            { id: 2, title: "Material", content: "Durable & Lightweight Polyester" },
            { id: 3, title: "Design", content: "Compact & Easy to Store in Your Vehicle" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Rachel Green",
                date: "March 15, 2025",
                rating: 5,
                content: "This luggage is perfect for road trips! It holds everything I need and fits easily in the car.",
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "John Turner",
                date: "March 20, 2025",
                rating: 4.7,
                content: "Great quality and spacious. I can pack everything without worrying about space.",
            },
        ],
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Navigation System",
        price: 250,
        disprice: 200,
        stock: 20,
        content:
            "Navigate with ease using our advanced Car Navigation System, featuring real-time GPS, voice guidance, and detailed maps for a stress-free driving experience.",
        description:
            "Our Car Navigation System offers turn-by-turn directions, live traffic updates, and offline map support. With a user-friendly interface, it’s the perfect companion for any road trip or daily commute.",
        category: ["Car Accessories", "Technology & Gadgets"],
        tags: ["GPS", "Navigation", "Car"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Display", content: "7-Inch Touchscreen HD Display" },
            { id: 2, title: "Traffic Updates", content: "Live Traffic Updates & Route Rerouting" },
            { id: 3, title: "Connectivity", content: "Bluetooth, USB, and AUX Support" },
            { id: 4, title: "Warranty", content: "2-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Michael Scott",
                date: "March 15, 2025",
                rating: 5,
                content: "This navigation system is fantastic! The screen is large and clear, and the voice guidance is spot on.",
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Rachel Green",
                date: "March 20, 2025",
                rating: 4.9,
                content: "Very easy to use, and the traffic updates have saved me so much time. Love it!",
            },
        ],
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Car Tire",
        price: 120,
        disprice: 100,
        stock: 20,
        content:
            "Be prepared for the unexpected with our durable Spare Car Tire, designed to get you back on the road in no time.",
        description:
            "Our Spare Car Tire is built to withstand tough conditions, featuring a rugged design for enhanced durability and reliability. It’s easy to store and comes in a range of sizes to fit most vehicles.",
        category: ["Car Maintenance", "Safety & Emergency"],
        tags: ["Tire", "Car", "Emergency"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Durability", content: "Built to Withstand Tough Conditions" },
            { id: 2, title: "Storage", content: "Compact Design for Easy Storage" },
            { id: 3, title: "Compatibility", content: "Fits Most Standard Vehicle Models" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Noah Carter",
                date: "March 15, 2025",
                rating: 5,
                content: "Great quality and durability. It was easy to install and gave me peace of mind on the road.",
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Olivia Miller",
                date: "March 20, 2025",
                rating: 4.8,
                content: "I always keep this spare tire in my trunk. It’s a lifesaver when I need it!",
            },
        ],
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Emergency Toolkit",
        price: 45,
        disprice: 35,
        stock: 25,
        content:
            "Be prepared for any roadside emergency with our Car Emergency Toolkit, equipped with essential tools for quick fixes and safety.",
        description:
            "Our Car Emergency Toolkit includes a tire inflator, jumper cables, a multipurpose wrench, flashlight, and first-aid kit. Compact and easy to store, it's a must-have for every vehicle.",
        category: ["Safety & Emergency", "Car Accessories"],
        tags: ["Toolkit", "Emergency", "Car"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Contents", content: "Jumper Cables, Wrench, Tire Inflator, Flashlight, First-Aid Kit" },
            { id: 2, title: "Storage Case", content: "Durable & Compact Carrying Case" },
            { id: 3, title: "Usage", content: "Ideal for Roadside Emergencies & Maintenance" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "David Wilson",
                date: "March 15, 2025",
                rating: 5,
                content: "A lifesaver on the road! The jumper cables and inflator came in handy during a breakdown.",
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Jessica Brown",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Great toolkit with all the essentials. Compact and easy to store in my trunk!",
            },
        ],
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Mobile Holder",
        price: 20,
        disprice: 15,
        stock: 30,
        content:
            "Keep your phone secure and within easy reach with our Car Mobile Holder, designed for a safe and convenient driving experience.",
        description:
            "Our Car Mobile Holder is adjustable to fit most phones, with a strong grip to prevent slipping. It can be mounted on your dashboard or air vent, allowing you to use GPS and hands-free calls while keeping your focus on the road.",
        category: ["Car Accessories", "Technology & Gadgets"],
        tags: ["Phone", "Holder", "Car"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Compatibility", content: "Fits All Smartphones" },
            { id: 2, title: "Mounting", content: "Can Be Mounted on Dashboard or Air Vent" },
            { id: 3, title: "Adjustable", content: "360° Rotation for Easy Viewing" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "John Doe",
                date: "March 15, 2025",
                rating: 5,
                content: "This mobile holder is perfect! It holds my phone securely and makes using GPS while driving easy.",
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Emily Smith",
                date: "March 20, 2025",
                rating: 4.9,
                content: "Great product! The adjustable feature works well, and it's very sturdy on my air vent.",
            },
        ],
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Car Pouch",
        price: 18,
        disprice: 15,
        stock: 40,
        content:
            "Maximize your car's storage space with our versatile Car Storage Pouch, perfect for organizing small items and keeping your vehicle tidy.",
        description:
            "Our Car Storage Pouch is designed to keep essential items organized and easily accessible. With a durable, compact design, it fits perfectly in your car’s interior, ideal for storing documents, gadgets, and other small essentials.",
        category: ["Car Accessories", "Travel & Luggage"],
        tags: ["Storage", "Pouch", "Car"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Capacity", content: "Spacious Enough for Documents, Gadgets, and Small Items" },
            { id: 2, title: "Material", content: "Durable & Water-Resistant Fabric" },
            { id: 3, title: "Design", content: "Compact & Lightweight for Easy Storage" },
            { id: 4, title: "Warranty", content: "1-Year Limited Warranty" },
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sarah Johnson",
                date: "March 15, 2025",
                rating: 5,
                content: "This pouch is amazing! It keeps my car organized, and I can easily find my essentials.",
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Michael Lee",
                date: "March 20, 2025",
                rating: 4.7,
                content: "Great product! It holds a lot and fits perfectly in the car without taking up too much space.",
            },
        ],
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Motor Oil",
        price: 25,
        disprice: 20,
        stock: 50,
        content:
            "Keep your engine running smoothly with our high-quality Car Motor Oil, designed for optimal performance and longevity.",
        description:
            "Our Car Motor Oil is formulated to provide excellent lubrication, reduce engine wear, and improve fuel efficiency. It’s suitable for most vehicles, ensuring your car operates at its best under all driving conditions.",
        category: ["Car Accessories", "Travel & Luggage"],
        tags: ["Oil", "Motor", "Car"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Viscosity", content: "5W-30 for Optimal Engine Performance" },
            { id: 2, title: "Protection", content: "Reduces Engine Wear and Tear" },
            { id: 3, title: "Efficiency", content: "Improves Fuel Efficiency & Reduces Emissions" },
            { id: 4, title: "Compatibility", content: "Compatible with Most Car Models" },
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Jacob Turner",
                date: "March 15, 2025",
                rating: 5,
                content: "Excellent oil! My engine runs smoother, and I've noticed better fuel efficiency since I switched.",
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Mia Anderson",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Great product! Keeps my engine well-lubricated and running quietly. I’m satisfied with the performance.",
            },
        ],
    }

];

export default products;